import type { Variants } from "framer-motion"

export function wrap(min: number, max: number, v: number) {
  const rangeSize = max - min
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min
}

export const SWIPE_CONFIDENCE_THRESHOLD = 10000
export function swipePower(offset: number, velocity: number) {
  return Math.abs(offset) * velocity
}

export const VARIANTS: Variants = {
  enter(direction: number) {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    }
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit(direction: number) {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    }
  },
}
